import { Center, Loader } from "@mantine/core";
import { RptRecentOrderHistories } from "types/model.types";

import { safeApiCall } from "api/common.service";
import { getRecentOrderDetails } from "api/report.service";
import { MAX_PAGE_SIZE } from "common/constants";
import { formatDate } from "common/utils";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const CustomerOrderPreview: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<RptRecentOrderHistories | null>();

  const [params] = useSearchParams();
  const year = params.get("y");
  const startCode = params.get("f");
  const endCode = params.get("t");

  useEffect(() => {
    if (!year) return;
    let mounted = true;

    const fetchData = async () => {
      try {
        const from: number | null = startCode ? Number(startCode) : null;
        const to: number | null = endCode ? Number(endCode) : null;

        const result = await safeApiCall(
          getRecentOrderDetails(from, to, Number(year), MAX_PAGE_SIZE, 1),
        );
        if (mounted && result) setData(result?.data ?? []);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }
  return (
    <div>
      <div className="sub-title">Customer Orders Report</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Date</th>
            <th>Product Code</th>
            <th className="description">Description</th>
            <th className="number">Ordered</th>
            <th className="number">Suplied</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((row, index) => (
              <tr key={`${index}-${row.id}`}>
                <td>{row.id}</td>
                <td>{formatDate(row.createdOn)}</td>
                <td>{row.productId}</td>
                <td className="description">{row.description}</td>
                <td className="number">{row.ordered}</td>
                <td
                  className="number"
                  style={{
                    fontWeight: row.ordered !== row.supplied ? "700" : "normal",
                  }}
                >
                  {row.supplied}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerOrderPreview;
